import React, { useEffect } from 'react'
import {  Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../_metronic/helpers'
import { Claim } from '../../auth/core/_models'


type Props = {
    show: boolean
    handleClose: () => void
    Claim: Claim[]
}

export const ClaimModel: React.FC<Props> = ({ show, handleClose ,Claim}) => {
    useEffect(() => {
        initMap()
    }, [])

    //const [location, setLocation] = useState(data.location)
    const dissmissLocation = () => {
        //setLocation(data.location)
        handleClose()
    }

    const initMap = () => { }

    return (
        <Modal
            className='modal fade'
            id='kt_modal_test'
            data-backdrop='static'
            tabIndex={-1}
            role='model'
            show={show}
            dialogClassName=' modal-dialog-scrollable'
            aria-hidden='true'
            onHide={dissmissLocation}
        >
            <div className='modal-content'>
                <div className='modal-header'>
                    <h5 className='modal-title'>Claims</h5>

                    <div
                        className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                        onClick={dissmissLocation}
                    >
                        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
                    </div>
                </div>
                <div className='modal-body'>
                    <div className='card card-xl-stretch mb-xl-8'>
                        {/* begin::Header 
                        <div className='card-header border-0'>
                           

                        </div>
                        {/* end::Header */}
                        {/* begin::Body */}
                        <div className='card-body pt-0'>
                            {
                                
                                Claim.map((claim, index) => {
                                    return (
                                        <>
                                            {/* begin::Item */}
                                            < div className='d-flex shadow-sm align-items-center bg-light-success rounded p-5 mb-7' key={index} >

                                                {/* begin::Title */}
                                                <div className='flex-grow-1 me-2'>

                                                    <div className='fw-bolder text-black text-hover-primary fs-6'>
                                                        {claim.ClaimType} Claim - {claim.ClaimNo}
                                                    </div>
                                                    {
                                                        claim.IntimationDate !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Registred on {claim.IntimationDate}
                                                        </span>
                                                    }
                                                    {
                                                        claim.PatientName !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Patient Name : {claim.PatientName}
                                                        </span>
                                                    }
                                                    {
                                                        claim.PatientName !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Relation : {claim.Relation}
                                                        </span>
                                                    }
                                                    {
                                                        claim.Diagnosis !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Diagnosis  : {claim.Diagnosis}
                                                        </span>
                                                    }
                                                    {
                                                        claim.Hospital !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Hospital Name  : {claim.Hospital}
                                                        </span>
                                                    }
                                                    {
                                                        claim.DateOfAdmission !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Date Of Admission  : {claim.DateOfAdmission}
                                                        </span>
                                                    }
                                                    {
                                                        claim.DateOfDischarge !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Date Of Discharge  : {claim.DateOfDischarge}
                                                        </span>
                                                    }
                                                    {
                                                        claim.ApprovedDate !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Approved Date  : {claim.ApprovedDate}
                                                        </span>
                                                    }
                                                    {
                                                        claim.SettledDate !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Settled Date  : {claim.SettledDate}
                                                        </span>
                                                    }
                                                    {
                                                        claim.ClaimedAmount !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Claimed Amount  : {claim.ClaimedAmount}
                                                        </span>
                                                    }
                                                    {
                                                        claim.ApprovedAmount !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Approved Amount  : {claim.ApprovedAmount}
                                                        </span>
                                                    }
                                                    {
                                                        claim.Deductions !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Deductions  : {claim.Deductions}
                                                        </span>
                                                    }
                                                    {
                                                        claim.ReasonForDeduction !== "" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            Reason For Deduction  : <span className='text-gray-700'> {claim.ReasonForDeduction} </span>
                                                        </span>
                                                    }
                                                    {
                                                        claim.BalanceSuminsured !== "0" &&
                                                        <span className='text-black fw-bold d-block'>
                                                            As on Date Balance Suminsured  : <span className='text-gray-700'> {claim.BalanceSuminsured} </span>
                                                        </span>
                                                    }
                                                </div>
                                                {/* end::Title */}
                                                <span className='fw-bolder text-success py-1'>{claim.ClaimStatus}</span>
                                            </div>
                                            {/* end::Item */}
                                        </>
                                    )
                                }
                                )
                            }
                        </div>
                        {/* end::Body */}
                    </div>

                </div>

            </div >
        </Modal >

    )
}

